document.addEventListener("DOMContentLoaded", () => {
  const duration = 0.75;
  const ease = "cubic-bezier(0.4, 0, 0.2, 1)";

  // Add GSAP timeline .js-svg-frame animation w/ ScrollTrigger tracking
  document.querySelectorAll(".js-animate-frame").forEach((v) => {
    const tl = gsap.timeline({ paused: true });
    const percentagefromCenter = 300;

    tl.fromTo(
      v.querySelector(".corner-group"),
      {
        opacity: 0,
        scale: 0,
        rotation: 90,
        transformOrigin: "center center",
      },
      {
        ease: ease,
        duration: duration / 3,
        transformOrigin: "center center",
        opacity: 1,
        scale: 1,
        rotation: 0,
      }
    );

    tl.fromTo(
      v.querySelector(".top-left"),
      {
        // opacity: 0,
        yPercent: percentagefromCenter,
        xPercent: percentagefromCenter,
      },
      {
        ease: ease,
        opacity: 1,
        duration: duration,
        yPercent: 0,
        xPercent: 0,
      }
    );
    tl.fromTo(
      v.querySelector(".top-right"),
      {
        // opacity: 0,
        yPercent: percentagefromCenter,
        xPercent: 0 - percentagefromCenter,
      },
      {
        ease: ease,
        opacity: 1,
        duration: duration,
        yPercent: 0,
        xPercent: 0,
      },
      "<"
    );
    tl.fromTo(
      v.querySelector(".bottom-left"),
      {
        // opacity: 0,
        yPercent: 0 - percentagefromCenter,
        xPercent: percentagefromCenter,
      },
      {
        ease: ease,
        opacity: 1,
        duration: duration,
        yPercent: 0,
        xPercent: 0,
      },
      "<"
    );
    tl.fromTo(
      v.querySelector(".bottom-right"),
      {
        // opacity: 0,
        yPercent: 0 - percentagefromCenter,
        xPercent: 0 - percentagefromCenter,
      },
      {
        ease: ease,
        opacity: 1,
        duration: duration,
        yPercent: 0,
        xPercent: 0,
      },
      "<"
    );

    ScrollTrigger.create({
      trigger: v,
      scrub: true,
      start: "bottom bottom-=5%",
      end: "top top+=5%",
      onToggle: (self) => {
        if (self.isActive) {
          tl.play();
        }
      },
    });
  });

  // Add GSAP timeline animation for .js-animate-feature w/ ScrollTrigger tracking
  document.querySelectorAll(".js-animate-feature").forEach((v) => {
    const tl = gsap.timeline({ paused: true });

    tl.fromTo(
      v.querySelector("svg"),
      {
        opacity: 0,
        y: 20,
      },
      {
        ease: ease,
        duration: duration,
        opacity: 1,
        y: 0,
      },
      duration
    );

    tl.addLabel("specific-animation-start");

    switch (v.getAttribute("data-svg-path")) {
      case "features/biometrics/animated":
        let dotDelay = 0;
        let lineDelay = 0;

        const dotFrom = {
          opacity: 0,
          y: 20,
        };

        const dotTo = {
          opacity: 1,
          y: 0,
          ease: ease,
          duration: duration / 2,
        };

        v.querySelectorAll(".dot").forEach((instance) => {
          dotDelay = dotDelay + 0.1;

          tl.fromTo(
            instance,
            dotFrom,
            dotTo,
            `specific-animation-start+=${dotDelay}`
          );
        });

        v.querySelectorAll(".line").forEach((instance) => {
          tl.fromTo(
            instance,
            {
              drawSVG: "0%",
            },
            {
              duration: duration / 2,
              drawSVG: "100%",
            },
            `specific-animation-start+=${lineDelay}`
          );

          lineDelay = lineDelay + 0.05;
        });

        break;
      case "features/dashboard/animated":
        tl.fromTo(
          v.querySelector(".tile-1"),
          {
            opacity: 0,
            y: 144,
          },
          {
            opacity: 1,
            y: 124,
            ease: ease,
            duration: duration,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".tile-2"),
          {
            opacity: 0,
            y: 144,
          },
          {
            opacity: 1,
            y: 124,
            ease: ease,
            duration: duration,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".tile-3"),
          {
            opacity: 0,
            y: 144,
          },
          {
            opacity: 1,
            y: 124,
            ease: ease,
            duration: duration,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".tile-4"),
          {
            opacity: 0,
            y: 249,
          },
          {
            opacity: 1,
            y: 229,
            ease: ease,
            duration: duration,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".tile-5"),
          {
            opacity: 0,
            y: 249,
          },
          {
            opacity: 1,
            y: 229,
            ease: ease,
            duration: duration,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".tile-6"),
          {
            opacity: 0,
            y: 249,
          },
          {
            opacity: 1,
            y: 229,
            ease: ease,
            duration: duration,
          },
          `<+=${duration / 3}`
        );

        break;
      case "features/direct-debit/animated":
        v.querySelectorAll(".input").forEach((instance, index) => {
          tl.fromTo(
            instance,
            {
              y: 20,
              opacity: 0,
            },
            {
              y: 0,
              opacity: 1,
              ease: ease,
              duration: duration / 2,
            },
            `>-${duration / 4}`
          );
        });

        tl.fromTo(
          v.querySelector(".signature"),
          {
            drawSVG: "0%",
          },
          {
            drawSVG: "100%",
            ease: ease,
            duration: duration,
          }
        );

        break;
      case "features/e-forms/animated":
        let buttonDelay = 0;

        v.querySelectorAll(".browser-button").forEach((instance) => {
          tl.fromTo(
            instance,
            {
              y: 20,
              opacity: 0,
            },
            {
              y: 0,
              opacity: 1,
              ease: ease,
              duration: duration / 2,
            },
            `specific-animation-start+=${buttonDelay}`
          );

          buttonDelay = buttonDelay + 0.1;
        });

        tl.fromTo(
          v.querySelector(".pane-1"),
          {
            y: 93,
            opacity: 0,
          },
          {
            y: 73,
            opacity: 1,
            ease: ease,
            duration: duration / 2,
          },
          "specific-animation-start"
        );

        tl.addLabel("first-pane-in");

        tl.fromTo(
          v.querySelector(".pane-2"),
          {
            y: 145.32,
            opacity: 0,
          },
          {
            y: 125.32,
            opacity: 1,
            ease: ease,
            duration: duration / 2,
          },
          `>-${duration / 4}`
        );

        tl.fromTo(
          v.querySelector(".pane-3"),
          {
            y: 147,
            opacity: 0,
          },
          {
            y: 127,
            opacity: 1,
            ease: ease,
            duration: duration / 2,
          },
          "first-pane-in"
        );

        tl.fromTo(
          v.querySelector(".pane-4"),
          {
            y: 235,
            opacity: 0,
          },
          {
            y: 215,
            opacity: 1,
            ease: ease,
            duration: duration / 2,
          },
          `>-${duration / 4}`
        );

        break;
      case "features/e-id/animated":
        let thumbDelay = 0;

        tl.fromTo(
          v.querySelector(".thumb-3"),
          {
            opacity: 0,
            y: 3,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          }
        );

        tl.fromTo(
          v.querySelector(".thumb-1"),
          {
            opacity: 0,
            y: -5,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".thumb-4"),
          {
            opacity: 0,
            y: -8,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".thumb-2"),
          {
            opacity: 0,
            y: 3,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".thumb-7"),
          {
            opacity: 0,
            y: 10,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".thumb-6"),
          {
            opacity: 0,
            y: -10,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".thumb-5"),
          {
            opacity: 0,
            y: 20,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".cylinder-1"),
          {
            opacity: 0,
            y: 288.999657,
          },
          {
            opacity: 1,
            y: 268.999657,
            ease: ease,
            duration: duration,
          },
          "specific-animation-start"
        );

        tl.fromTo(
          v.querySelector(".cylinder-2"),
          {
            opacity: 0,
            y: 264,
          },
          {
            opacity: 1,
            y: 244,
            ease: ease,
            duration: duration,
          },
          `specific-animation-start+=${duration / 2}`
        );

        tl.fromTo(
          v.querySelector(".line-1"),
          {
            opacity: 0,
          },
          {
            opacity: 1,
            ease: ease,
            duration: duration,
          }
        );

        tl.fromTo(
          v.querySelector(".line-2"),
          {
            opacity: 0,
          },
          {
            opacity: 1,
            ease: ease,
            duration: duration,
          },
          "<"
        );

        tl.fromTo(
          v.querySelector(".passport"),
          {
            opacity: 0,
            y: 224,
          },
          {
            opacity: 1,
            y: 204,
            ease: ease,
            duration: duration,
          },
          `specific-animation-start+=${duration / 2}`
        );

        tl.fromTo(
          v.querySelector(".identification"),
          {
            opacity: 0,
            y: 151,
          },
          {
            opacity: 1,
            y: 131,
            ease: ease,
            duration: duration,
          },
          `specific-animation-start+=${duration}`
        );

        break;
      case "features/e-signature/animated":
        // Animate asterix's
        tl.fromTo(
          v.querySelector(".asterix-1"),
          {
            opacity: 0,
            y: 10,
          },
          {
            ease: ease,
            duration: duration / 2,
            y: 0,
            opacity: 1,
          },
          "specific-animation-start"
        );

        tl.fromTo(
          v.querySelector(".asterix-2"),
          {
            opacity: 0,
            y: 10,
          },
          {
            ease: ease,
            duration: duration / 2,
            y: 0,
            opacity: 1,
          },
          `<+=${duration / 3}`
        );

        tl.fromTo(
          v.querySelector(".asterix-3"),
          {
            opacity: 0,
            y: 10,
          },
          {
            ease: ease,
            duration: duration / 2,
            y: 0,
            opacity: 1,
          },
          `<+=${duration / 3}`
        );

        // Animate squiggly signature
        tl.fromTo(
          v.querySelector(".signature"),
          {
            drawSVG: "0%",
          },
          {
            ease: ease,
            duration: duration,
            drawSVG: "100%",
          },
          "specific-animation-start"
        );

        tl.fromTo(
          v.querySelector(".padlock"),
          {
            opacity: 0,
            y: 10,
          },
          {
            duration: duration,
            ease: ease,
            opacity: 1,
            y: 0,
          },
          "specific-animation-start"
        );

        break;
      case "features/kba/animated":
        tl.fromTo(
          v.querySelector(".speech-large"),
          {
            opacity: 0,
            y: 20,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration,
          },
          "specific-animation-start"
        );

        tl.fromTo(
          v.querySelector(".speech-small"),
          {
            opacity: 0,
            y: 20,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          `>-${duration / 2}`
        );

        tl.fromTo(
          v.querySelector(".input"),
          {
            opacity: 0,
            width: 0,
            x: 71,
          },
          {
            opacity: 1,
            x: 0,
            width: 142,
            ease: ease,
            duration: duration / 3,
          }
        );

        tl.fromTo(
          v.querySelector(".lock-button"),
          {
            opacity: 0,
            width: 0,
            x: 42.7,
          },
          {
            opacity: 1,
            width: 85.42,
            ease: ease,
            x: 0,
            duration: duration / 3,
          }
        );

        tl.fromTo(
          v.querySelector(".question"),
          {
            opacity: 0,
            y: 20,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          }
        );

        tl.fromTo(
          v.querySelector(".lock"),
          {
            opacity: 0,
            y: 20,
          },
          {
            opacity: 1,
            y: 0,
            ease: ease,
            duration: duration / 2,
          },
          "<"
        );

        break;
      case "features/liveness/animated":
        tl.fromTo(
          v.querySelector(".rect-1"),
          {
            opacity: 0,
            width: 0,
            x: 144,
          },
          {
            opacity: 1,
            width: 281.852,
            x: 0,
            ease: ease,
            duration: duration,
          },
          "specific-animation-start"
        );

        v.querySelectorAll(".rect-2").forEach((instance) => {
          tl.fromTo(
            instance,
            {
              width: 0,
              opacity: 0,
              x: 31.125,
            },
            {
              width: 62.513,
              opacity: 1,
              x: 0,
              ease: ease,
              duration: duration,
            },
            "specific-animation-start"
          );
        });

        tl.fromTo(
          v.querySelector(".rect-3"),
          {
            width: 0,
            opacity: 0,
            x: 54.7905,
          },
          {
            width: 109.581,
            opacity: 1,
            x: 0,
            ease: ease,
            duration: duration,
          },
          "specific-animation-start"
        );

        tl.addLabel("rects-in");

        v.querySelectorAll(".dot-1").forEach((instance) => {
          tl.fromTo(
            instance,
            {
              opacity: 0,
              y: 20,
            },
            {
              opacity: 1,
              y: 0,
              ease: ease,
              duration: duration / 4,
            },
            "rects-in"
          );
        });

        tl.addLabel("dot-1-in");

        v.querySelectorAll(".dot-2").forEach((instance) => {
          tl.fromTo(
            instance,
            {
              opacity: 0,
              y: 20,
            },
            {
              opacity: 1,
              y: 0,
              ease: ease,
              duration: duration / 4,
            },
            "dot-1-in"
          );
        });

        tl.addLabel("dot-3-in");

        v.querySelectorAll(".dot-3").forEach((instance) => {
          tl.fromTo(
            instance,
            {
              opacity: 0,
              y: 20,
            },
            {
              opacity: 1,
              y: 0,
              ease: ease,
              duration: duration / 4,
            },
            "dot-3-in"
          );
        });

        tl.addLabel("dot-4-in");

        v.querySelectorAll(".dot-4").forEach((instance) => {
          tl.fromTo(
            instance,
            {
              opacity: 0,
              y: 20,
            },
            {
              opacity: 1,
              y: 0,
              ease: ease,
              duration: duration / 4,
            },
            "dot-4-in"
          );
        });

        break;
    }

    ScrollTrigger.create({
      trigger: v,
      scrub: true,
      start: "bottom bottom",
      end: "top top+=5%",
      onToggle: (self) => {
        if (self.isActive) {
          tl.play();
        }
      },
    });
  });

  // Add GSAP timeline .js-icon-shield animation w/ ScrollTrigger tracking
  document.querySelectorAll(".js-icon-shield").forEach((v) => {
    const tl = gsap.timeline({ paused: true });

    tl.fromTo(
      v.querySelector(".shield"),
      {
        scale: 0,
        opacity: 0,
        transformOrigin: "50% 50%",
      },
      {
        duration: 0.4,
        scale: 1,
        opacity: 1,
      },
      0
    )
      .fromTo(
        v.querySelector(".check-1"),
        {
          height: 0,
        },
        {
          duration: 0.2,
          height: 33,
        }
      )
      .fromTo(
        v.querySelector(".check-2"),
        {
          height: 0,
        },
        {
          duration: 0.2,
          height: 53,
        }
      );

    ScrollTrigger.create({
      trigger: v,
      scrub: true,
      start: "bottom bottom-=5%",
      end: "top top+=5%",
      onToggle: (self) => {
        if (self.isActive) {
          tl.play();
        }
      },
    });
  });
});
